import { render } from "./SimpleDonutChart.vue?vue&type=template&id=21d77cba"
import script from "./SimpleDonutChart.vue?vue&type=script&lang=js"
export * from "./SimpleDonutChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__